<div class="row">
  <div class="pe-3 pb-3">
    <bs-datepicker-inline [bsValue]="bsInlineValue"></bs-datepicker-inline>
  </div>
  <div class="pe-3 pb-3">
    <bs-daterangepicker-inline [bsValue]="bsInlineRangeValue"></bs-daterangepicker-inline>
  </div>
</div>
